import { AppConsts } from "@shared/app-consts";

export class GRecaptchaService{

    static submitWithCaptcha = (actionSubmit: any, event: any, actionName: string) => {
        const grecaptcha = window["grecaptcha"];
        if (grecaptcha) {
          grecaptcha.ready(() => {
            grecaptcha.execute(AppConsts.RECAPTCHA_SITE_KEY, { action: actionName })
              .then((token) => {
                actionSubmit(event, token);
              });
          });
        }
      }

      static initGRecaptcha = () => {
        const loadScriptByURL = (id, url) => {
          const isScriptExist = document.getElementById(id);
          if (!isScriptExist) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.id = id;
            document.body.appendChild(script);
          }
        };
        loadScriptByURL(
          'recaptcha-key',
          `https://www.google.com/recaptcha/api.js?render=${AppConsts.RECAPTCHA_SITE_KEY}`
        );
      };
}